import React, { Fragment } from "react";
import clsx from 'clsx';

import Box from "@mui/material/Box";
import Top from "@xem/icon/base/Top";
import Button from "reactstrap/lib/Button";
import WidgetBox from "@gqlapp/base/View/WidgetBox";
import ControlRender from "../render/Control";
import Radios from "@gqlapp/fields/RadiosBox";
import { FieldAdapter as Field } from "@gqlapp/forms-client-react";
import getBody, { BodyShape as icons } from './BodyShape';
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import BaseConfig from "@xem/look/utils/fieldConfig";
import Group from "@gqlapp/utils/Group";
import RenderSlider from "@gqlapp/fields/Slider";

const BaseForm = ((props) => {
	let { values, setFieldValue } = props;
	let { setScrollTop, zoomin } = props;
	let { selectedIndex } = values;

	let options = icons.map((values, value)=>({
		...values, value
	}));


	const sx = {
		padding: '0 15px 15px', backgroundColor: '#ffffff',
		'& .MuiFormControl-root':{ marginTop: '8px', marginBottom: 0, minHeight: '54px' },
		'& >.row':{
			paddingTop: '15px',
			'& > .col':{ alignItems: 'center', alignContent: 'center' }
		}
	}


	let group = {
		...sx,
		paddingleft: '15px',
		paddingRight: '15px',
		paddingBottom: '0px',
		'& .MuiFormGroup-root':{ minHeight: '30px' },
		'& .MuiFormControl-root':{
			minHeight: '40px',
			marginTop: 0,
			marginBottom: 0
		}
	}


	function sliderConfig(props){
		return {
			className: clsx('slider', 'crop-slider', 'd-flex align-items-center'),
			onBlur: () => {},
			onFocus: () => {},
			component: RenderSlider,
			onChange: setFieldValue,
			...props
		}
	}

	const Control = ControlRender(options)
	const currentBody = getBody(selectedIndex);

	return (<>
		<Box>
			<Button
				onClick={() => setScrollTop(true)}
				color={'default'} className={clsx('p-0', 'circle-up', {'in': zoomin})}
				style={{ position: 'fixed', bottom: '60px', right: '2px', zIndex: 10 }}>
				<Top/>
			</Button>
			<>
				{(!!currentBody?.has_data)  && <Group sx={group} className={clsx({label_on: values?.settings?.on})}>
					<Row>
						<Col>{`qr:qrcode.dataSize.title`.t()}</Col>
						<Col xs={'auto'} className={'d-flex align-items-center'} sx={{width: '130px !important'}}>
							<Box {...{sx: {width: '100%'}}}>
								<Field {...sliderConfig({name: 'size', value: values?.size, min: 30, max: 100, step: 1})} />
							</Box>
						</Col>
						<Col className={'d-flex align-items-center'} xs={'auto'} sx={{width: '80px !important'}}>
							<Field {...BaseConfig({name: `size`, value: values?.size})} />
						</Col>
					</Row>
					<Row>
						<Col>{`qr:qrcode.strokeWidth.title`.t()}</Col>
						<Col xs={'auto'} className={'d-flex align-items-center'} sx={{width: '130px !important'}}>
							<Box {...{sx: {width: '100%'}}}>
								<Field {...sliderConfig({
									name: 'strokeWidth',
									value: values?.strokeWidth,
									min: 0,
									max: 100,
									step: 1
								})} />
							</Box>
						</Col>

						<Col className={'d-flex align-items-center'} xs={'auto'} sx={{width: '80px !important'}}>
							<Field {...BaseConfig({name: `strokeWidth`, value: values?.strokeWidth})} />
						</Col>
					</Row>
				</Group>}
				<WidgetBox
					{...{
						title: 'qr:title.data'.t(),
						color: 'qrcode',
						className: 'qrcode-data'
					}}
				>
					<Field
						{...{ component: Radios }}
						{...{ classNameGroup: 'frame-body qrcode-grid row row-small', classNameLabel: 'col-auto'}}
						{...{ value: selectedIndex, name: 'selectedIndex', options, onChange: setFieldValue }}
						{...{ control: <Control /> }}
					/>
				</WidgetBox>
			</>
		</Box>
	</>)
})


export default BaseForm;